import { ref } from 'vue';
import { Badge } from '@capawesome/capacitor-badge';

export function useBadge() {

    const badge = ref<number>(0);

    const get = async () => {
        const result = await Badge.get();
        return result.count;
    };

    const set = async (count: number) => {
        await Badge.set({ count });
    };

    const increase = async () => {
        await Badge.increase();
    };

    const decrease = async () => {
        await Badge.decrease();
    };

    const clear = async () => {
        await Badge.clear();
    };

    const isSupported = async () => {
        const result = await Badge.isSupported();
        return result.isSupported;
    };

    const checkPermissions = async () => {
        const result = await Badge.checkPermissions();
    };

    const requestPermissions = async () => {
        const result = await Badge.requestPermissions();
    };

    return {
        badge,
        get,
        set,
        increase,
        decrease,
        clear,
        isSupported,
        checkPermissions,
        requestPermissions,    
    };
};

